import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

export default function AddSupplierModal() {
	const classes = useStyles();
	const [open, setOpen] = React.useState(false);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<div>
			{/* <button type="button" onClick={handleOpen}>
				react-transition-group
			</button> */}
			<Button variant="outlined" color="primary" onClick={handleOpen}>
				Add Item Order
			</Button>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>
					<div className={classes.paper}>
						<h2 id="transition-modal-title">Add Item</h2>
						<form action="" className={classes.root}>
							<Grid container spacing={3}>
								<Grid item xs={3}>
									Item
								</Grid>
								<Grid item xs={9}>
									<TextField
										required
										id="outlined-required"
										label="Item"
										variant="outlined"
									/>
								</Grid>
								<Grid item xs={3}>
									Quantity
								</Grid>
								<Grid item xs={9}>
									<TextField
										required
										id="outlined-required"
										label="Quantity"
										variant="outlined"
									/>
								</Grid>
							</Grid>
							<div className={classes.button}>
								<Button
									variant="contained"
									onClick={handleClose}
									className={classes.buttonMarginRight}
								>
									Close
								</Button>
								<Button variant="contained" color="primary">
									Add Inventory
								</Button>
							</div>
						</form>
					</div>
				</Fade>
			</Modal>
		</div>
	);
}
